<template>
  <div class="page-container">
    <CrmPageHeader
      title="Leads"
      subtitle="Gestión de prospectos y contactos"
      icon="fas fa-funnel-dollar"
    />

    <tableComponent :headers="headers" :items="leads.data" :spinner="spinner" name="Leads">
      <template #columnRender="{ header, value }">
        <span v-if="header.field === 'id'" style="font-weight:700; color:#2563EB">
          #{{ value.id }}
        </span>

        <span v-else-if="header.field === 'nombre'">
          {{ value.nombre || '—' }}
        </span>

        <span v-else-if="header.field === 'main_mail'" class="text-truncate-cell">
          {{ value.main_mail || '—' }}
        </span>

        <span v-else-if="header.field === 'main_cell_phone'">
          {{ value.main_cell_phone || '—' }}
        </span>

        <span v-else-if="header.field === 'subportalescode'">
          <span v-if="value.subportalescode?.length" style="display:flex;flex-wrap:wrap;gap:4px">
            <span
              v-for="item in value.subportalescode"
              :key="item.id"
              class="badge bg-light"
            >{{ item.subportal.name }}</span>
          </span>
          <span v-else style="color:#94A3B8">—</span>
        </span>

        <span v-else-if="header.field === 'portalescontact'">
          {{ value.portalescontact || '—' }}
        </span>

        <span v-else-if="header.field === 'actions'">
          <a href="#" class="table-action-link" title="Ver detalle">
            <i class="fas fa-eye"></i>
          </a>
        </span>
      </template>

      <template #headers></template>
      <template v-slot:pagination></template>
    </tableComponent>
  </div>
</template>

<script>
import tableComponent from '@/components/tableComponent.vue'
import CrmPageHeader from '@/components/CrmPageHeader.vue'
import { useLeads } from './useLeads.js'

export default {
  name: 'leads',
  components: { tableComponent, CrmPageHeader },
  setup() {
    const { headers, getLeads, leads, spinner } = useLeads()
    getLeads()
    return { leads, headers, spinner }
  },
}
</script>

<style scoped>
.text-truncate-cell {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>
